import React from 'react';
import {
    Container,
    Image,
    Segment,
} from 'semantic-ui-react';

import { useBodyClass } from '../hooks';

const Donation = () => {

    useBodyClass('donation');

    return (
        <Container style={{ marginTop: '20px' }}>
            <Segment className='lobby'>
                <p>Thank you for your donation! If you selected an incentive, it will be triggered in the game immediately!</p>
            </Segment>

            <center>
                Powered by<br />
                <a href='/'><Image style={{ display: 'inline' }} size='medium' src="/images/toilogo.png" /></a>
            </center>
        </Container>
    )
};

export default Donation;
